export let props = ['visible', 'caseId', 'carBlacklistId', 'manBlacklistId', 'dodgingTollId']
export let model = {
  activeName: undefined,
  tabs: [{
    label: '证件照片',
    name: 'credentials'
  }, {
    label: '补交告知书',
    name: 'noticesPaper'
  }, {
    label: '补交自愿书',
    name: 'volunteerPaper'
  }, {
    label: '补交收据',
    name: 'receipt'
  }, {
    label: '补交处理单',
    name: 'handlePaper'
  }],
  data: {
    credentials: [],
    noticesPaper: [],
    volunteerPaper: [],
    receipt: [],
    handlePaper: []
  },
  selections: {
    credentials: [],
    noticesPaper: [],
    volunteerPaper: [],
    receipt: [],
    handlePaper: []
  },
  uploadLoading: false,
  files: [],
  rename: {
    visible: false,
    newFileName: {}
  }
}
export let computed = {
  dialogVisible: {
    get () {
      return this.visible
    },
    set (val) {
      this.$emit('update:visible', val)
    }
  },
  imgData () {
    let temp = {}
    let reg = /(.jpg$)|(.jpeg$)|(.png$)|(.bmp$)/
    for (let item in this.data) {
      let hasImgs = this.data[item].filter(file => {
        return reg.test(file.fileUrl)
      })
      temp[item] = hasImgs
    }
    return temp
  },
  dialogTitle () {
    if (this.caseId) {
      return '现场证据'
    } else if (this.manBlacklistId) {
      return '人脸黑名单处理'
    } else {
      return '车辆灰名单车辆'
    }
  }
}
